import { gql } from '@apollo/client'

export const UPDATE_ORDER_CUSTOMER = gql`
  mutation UpdateOrderCustomer($input: UpdateOneCustomerInput!) {
    updateOneCustomer(input: $input) {
      id
      firstName
      lastName
      email
      mobile
    }
  }
`
